// src/modules/clinical-info/common/constants.js

/**
 * Location options used across clinical-info module
 */
export const LOCATION_OPTIONS = [
  { id: 1, name: "Fort Myers" },
  { id: 2, name: "Port Saint Lucie" },
  { id: 3, name: "Immokalee" },
  { id: 4, name: "Lehigh" },
  { id: 5, name: "Naples" },
  { id: 6, name: "Lake Worth" },
  { id: 7, name: "Unassigned" }
];

/**
 * Extended location options (used in some tables with different data)
 */
export const EXTENDED_LOCATION_OPTIONS = [
  { id: 1, name: "FortMyers" },
  { id: 2, name: "FortPierce" },
  { id: 3, name: "Immokalee" },
  { id: 4, name: "Lehigh" },
  { id: 5, name: "Naples" },
  { id: 6, name: "LakeWorth" },
  { id: 7, name: "PortSaintLucie" },
  { id: 8, name: "Unassigned" },
];

/**
 * Insurance types for filtering
 */
export const INSURANCE_TYPE_OPTIONS = [
  { id: "ACA", name: "ACA - Health" },
  { id: "MED", name: "MED - Medicare" },
];

/**
 * Tab indices for clinical info navigation
 */
export const CLINICAL_TABS = {
  DISCHARGED: 0,
  ADMITTED: 1,
  EMERGENCY: 2,
  HIGH_COST: 3,
  HIGH_RISK: 4,
};
